/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { ControlTable } from "../Table";
import { getParams } from "../../utils/params";
import { isEmpty } from "lodash-es";
import { taskDetail, taskListFields } from "../../utils/task";
import { taskApproved, taskDenied, approvalsHandover, getTaskList } from "../../apis/tasks";
import systemAlert from "../../utils/systemAlert";
import TaskHandoverPopup from "./TaskHandoverPopup";
import { useDispatch, useSelector } from "react-redux";
import { taskListReload } from "../../store/actions";
import useForm from "../../hooks/useForm";
// import systemAlert from "../../utils/systemAlert";


const TaskTable = ({
  title,
  fixFilter = {},
  params = {},
  ownership,
  loadingColor,
  isButtons,
  isControl = true,
  isOpenToggle = true,
}) => {
  const [employeeSelectedList, setEmployeeSelectedList] = useState([]);
  const [isApprovalsHandoverPopup, setIsApprovalsHandoverPopup] = useState(false);
  // const [handoverReason, setHandoverReason] = useState("");

  const { taskToggle } = useSelector((store) => store.Task);
  const dispatch = useDispatch();

  const {
    form,
    setForm,
    setSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      ...params,
      page: 0,
      limit: 10
    },
  );

  useEffect(() => {
    setSubmit(submit);
  }, []);

  useEffect(() => {

    if (!isEmpty(params)) {
      let _params = {
        ...form,
        ...params,
      };

      if (isEmpty(params.search)) {
        _params.search = {};
      }

      setForm(_params);
      filterSubmit({
        params: _params
      });
    }
  }, [params, taskToggle]);

  const submit = (params = {}) => {
    getTaskList({
      ...getParams(params),
      ...fixFilter,
      ownership
    })
      .then((response) => {
        setTotal(response.data.totalCount);
        setList(response.data.approvalTargetList || []);
      })
      .catch((err) => {

      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const tableButtons = [
    // {
    //   label: "엑셀다운로드",
    //   color: "gray-line",
    //   action: () => { },
    //   isDisabled: isEmpty(selectedList),
    // },
    {
      label: "위임",
      color: "gray-line",
      action: () => {
        setIsApprovalsHandoverPopup(true);
      },
      disabled: isEmpty(selectedList),
    },
    {
      label: "반려",
      color: "red",
      action: () => {
        systemAlert(`${selectedList.length}건을 반려하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '반려',
              onClick: () => {
                taskDenied(selectedList.map(d => d.myTask.idx))
                  .then(() => {
                    dispatch(taskListReload());
                  });
              }
            }
          ]
        });
      },
      disabled: isEmpty(selectedList),
    },
    {
      label: "승인하기",
      color: "green",
      action: () => {
        systemAlert(`${selectedList.length}건을 승인하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '승인',
              onClick: () => {
                taskApproved(
                  selectedList.map(d => d.myTask.idx)
                )
                  .then(() => {
                    dispatch(taskListReload());
                  });
              }
            }
          ]
        });

      },
      disabled: isEmpty(selectedList),
    },
  ];

  const approvalsHandoverPopupClose = () => {
    setIsApprovalsHandoverPopup(false);
    // setHandoverReason('')
    setEmployeeSelectedList([]);
  };
  const approvalsHandoverPopupSubmit = ({ handoverReason, taskSelectedList, employeeSelectedList }) => {
    if (!employeeSelectedList[0]) {
      systemAlert('위임대상을 선택해주세요.');
      return;
    }
    approvalsHandover({
      taskIdxes: taskSelectedList.map(d => d.idx),
      handoverTargetEmpIdx: employeeSelectedList[0].idx,
      startDate: "2020-03-03",
      endDate: "2030-10-10",
      reason: handoverReason
    }).then(() => {
      dispatch(taskListReload());
      approvalsHandoverPopupClose();
    }).catch(() => { });
  };

  const openTaskDetail = (data, e) => {
    taskDetail(data);
  };

  return (
    <>
      <ControlTable
        isLoading={isLoading}
        isHideHeader={true}
        isOpenToggle={isOpenToggle}
        title={title}
        fields={taskListFields}
        list={list}
        buttons={isButtons && ownership === 'owner' ? tableButtons : []}
        selectedList={selectedList}
        setSelected={setSelectedList}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={isControl}
        loadingColor={loadingColor}
        onSelect={openTaskDetail}
      />

      <TaskHandoverPopup
        isOpen={isApprovalsHandoverPopup}
        close={approvalsHandoverPopupClose}
        taskSelectedList={selectedList}
        employeeSelectedList={employeeSelectedList}
        setEmployeeSelectedList={setEmployeeSelectedList}
        submit={approvalsHandoverPopupSubmit}
      ></TaskHandoverPopup>
    </>
  );
};

export default TaskTable;
